import { Box, Stack, Typography } from '@mui/material'
import { ApprovalSteps, ProvisionSteps } from 'components/pages/task/details/content/TaskApprovalChain'
import { TaskKeyValueMetadataRow } from 'components/pages/task/details/content/TaskKeyValueMetadataRow'
import { TaskValue } from 'lib/actions/task'
import { Gavel } from 'lucide-react'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type TaskExecutionPlanProps = {
    task: TaskValue
}

export const TaskExecutionPlan: FC<TaskExecutionPlanProps> = ({ task }) => {
    return <Stack gap={5}>
        <Box py={4}>
            <TaskKeyValueMetadataRow
                Icon={Gavel}
                label={<FormattedMessage id="components_task_dialog_access_review" defaultMessage="Policy" />}
                value={<Typography>{task.policy?.policy?.displayName}</Typography>}
            />
        </Box>
        <Box><ApprovalSteps task={task} /></Box>
        <Box pb={4}><ProvisionSteps task={task} /></Box>
    </Stack>
}
